// extracted by mini-css-extract-plugin
export default {"container":"InspectionRecorder_container__+Om9v"};